import React, { useState, useEffect } from 'react'
import {
    useNavigate, useLocation
} from "react-router-dom";
import "./styles.scss"
import CloseCross from "../../assets/closeCross.svg"

function MainContent() {
    const [itemsMenu] = useState([
        { id: 0, linkto: "MyDatasets", text: 'Загруженные наборы', active: null },
        { id: 1, linkto: "ImportDataset", text: 'Импорт', active: null },
        { id: 2, linkto: "TuneMetadata", text: 'Настройка структуры', active: null },
        { id: 3, linkto: "Decomposer", text: 'Разбор адреса', active: null },
        { id: 4, linkto: "Normaliser", text: 'Нормализация', active: null },
        { id: 5, linkto: "GeometryTransformer", text: 'Трансформация геометрии', active: null },
        { id: 6, linkto: "Connector", text: 'Связывание с ОАП', active: null },
        { id: 7, linkto: "Exporter", text: 'Публикация на карту', active: null },
        { id: 8, linkto: "Tarifs", text: 'Тарифы', active: null },
    ]);

    const currentPath = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        let currPath = currentPath && currentPath.pathname.substring(currentPath.pathname.lastIndexOf('/')+1)
        itemsMenu.forEach((item)=>{
            if (item.linkto === currPath) item.active = true
        })
        if (document.getElementById("LkContainer")) document.getElementById("LkContainer").style.height = window.innerHeight / 100 * 7 > 55 ? (window.innerHeight - 55) + 'px' : '93%';
        console.log(window.innerHeight / 100 * 7);
    }, [])


    function openNavElement(event, link) {
        console.log(event, window.location.href+'/'+link)
        closeMenu()
        if ( event.ctrlKey || event.metaKey ) window.open(window.location.href.split('/lk')[0]+'/lk/'+link)
        else navigate('/lk/'+link)
    }

    function closeMenu() {
        console.log('closemenu')
        let menu = document.getElementById('MainMenu')
        if (menu && menu.style) menu.style.display = 'none'
    }
// return <></>
return <div className="menuDiv-blur" id="MainMenu" key={"keyMainMenu"}>
   <div className="menuDiv" id="LkContainer" key={"keyMainMenuLkContainer"}>

        <h3 className={"bigText"} key={"key1"}>Наборы данных</h3>
        {itemsMenu.map((n, i) => {
            if (i < 2) {
                return <div key={"key-"+n.linkto} onClick={(e) => {openNavElement(e, n.linkto)}} className={"textStyle " + (n.active ? 'active' : '')}>{n.text}</div>
            }
            else return <React.Fragment key={"key-1"+n.linkto}/>
        })}
        <div className='merginBetween'/>
        {/* <h3 className={"bigText"} key={"key2"}>Обработка</h3>
        {itemsMenu.map((n, i) => {
            if (i > 2 && i < 8) {
                return <div key={"key-"+n.linkto} onClick={(e) => {openNavElement(e, n.linkto)}} className={"textStyle " + (n.active ? 'active' : '')}>{n.text}</div>
            }
            else return <React.Fragment key={"key-2"+n.linkto}/>
        })} */}

        {/* <h3 className={"bigText"} key={"key3"}>Платные услуги</h3> */}
        
        {itemsMenu && itemsMenu[8] && <div className='commercialPlate' onClick={(e) => {openNavElement(e, itemsMenu[8].linkto)}}><p className='commercialButton'> Платные услуги </p></div>}
        <div className='closeMenu' onClick={closeMenu}><img className='closeIcon' src={CloseCross} alt='closeIcon'/></div>

    </div> </div> 

}

export default MainContent;
